import { useEffect, useState } from "react";
import { fetchPrismic, IDocument } from "src/services/fetchPrismic.service";

import { IPrismic, IPrismicData } from "../types";

interface IProps {
  name?: string;
  bannerData?: IPrismicData;
}

export const usePrismicData = ({
  name = "banner_handler",
  bannerData,
}: IProps = {}): IPrismicData => {
  const [prismicData, setPrismicData] = useState<IDocument<IPrismic> | null>(
    null
  );

  useEffect(() => {
    let mounted = true;
    const id = name;
    const type = name;
    const options = {
      graphQuery: ``,
    };

    // We can receive prismic data via props if fetchPrismic has been used before
    if (bannerData) {
      setPrismicData(bannerData);
    } else {
      fetchPrismic<IPrismic>(id, type, options).then(
        (data: IDocument<IPrismic> | null) => mounted && setPrismicData(data)
      );
    }

    return (): void => {
      mounted = false;
    };
  }, [bannerData, name]);

  return prismicData;
};
